export default __webpack_public_path__ + "static/2-5-0-0-5a6e784ad3e72593fec8e21a97c8c535.jpg";